export default "__VITE_ASSET__DRfWdgzd__"